import { useCallback } from 'react';

import environment from '../environment/environment';

const useLoadLearnosityReportsSDK = () => {
  const getLearnositySDK = useCallback((data: any) => {
    const scriptjs = require('scriptjs');

    scriptjs(environment.REACT_APP_LEARNOSITY_REPORTS_SDK_URL, function () {
      const callbacks = {
        readyListener() {},
        errorListener(err: any) {
          console.log(err);
        },
      };

      (window as any).LearnosityReports.init(JSON.parse(data.responseDataJson), callbacks);
    });
  }, []);

  return {
    getLearnositySDK,
  };
};

export default useLoadLearnosityReportsSDK;
